import slice from './slice';

const containerAppReducer = slice.reducer;

export const { setFieldContainerApp, addItem, viewItem } = slice.actions;

export default containerAppReducer;
